import React, { Component } from 'react';
import Dialog from 'react-bootstrap-dialog';
import { Button } from 'react-bootstrap';
import './Modal.css';
export class DialogConfirm extends Component {
  constructor(props) {
    super(props);
    console.log('DialogConfirm ', props);
    this.state = {};
  }

  componentDidMount() {}

  onClick = (e) => {
    e.preventDefault();
    // console.log('dialog ', e, 'props: ', this.props);
    console.log(this.props.obj);
    this.dialog.show({
      title: this.props.obj.title,
      body: this.props.obj.msg,
      actions: [
        Dialog.CancelAction(this.props.CancelAction),
        Dialog.OKAction(this.props.OKAction),
      ],
      bsSize: 'small',
      onHide: (dialog) => {
        //dialog.hide();
        console.log('close');
      },
    });
  };

  render() {
    return (
      <span ref={this.wrapper}>
        {/* <Button onClick={this.onClick}>Show alert</Button> */}
        <Dialog
          ref={(el) => {
            this.dialog = el;
          }}
          msgBox={{ msgBox: this.msgBox }}
        />

        <Button
          type='link'
          htmltype='button'
          className='btn btn-warning insute'
          onClick={this.onClick}
        >
          {this.props.obj.annulla}
        </Button>
      </span>
    );
  }
}

export default DialogConfirm;
